export default {
  name: 'CircleBlack Dark',
  displayName: 'Standard Dark',
  dark: true,
  backgroundColor: '#14171A',
  tileBackgroundColor: '#252B34',
  headerBackgroundColor: '#252B34',
  headerBackgroundOpacity: '0.9',
  primaryColor: '#00AEEF',
  secondaryColor: null,
  titleText: {
    name: 'ProximaLight',
    size: '18px',
    lineHeight: '20px',
    height: '40px',
  },
  bodyText: {
    name: 'ProximaRegular',
    size: '12px',
  },
  labelText: {
    name: 'ProximaLight',
    size: '10px',
  },
  primaryButtonText: {
    name: 'ProximaExtrabold',
  },
  secondaryButtonText: {
    name: 'ProximaLight',
  },
};
